import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import "./signin.scss";

import { getEndpoint } from "../helper";

export default function SignIn(props) {
    const history = useHistory();
    const [mobile, setMobile] = useState('');
    const [buttonClassName, setButtonClassName] = useState('_bc-g-g');
    const [isValid, setIsValid] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(getEndpoint("/api/android/auth/getcookie"), { credentials: "include" });
                if (response.ok) {
                    history.push('/');
                    return;
                }
            } catch (err) {
                console.log(err.message);
            } finally {
            }
        };

        fetchData();
    }, []);

    const handleMobileChange = e => {
        const { value, maxLength } = e.target;
        const mobile = value.slice(0, maxLength);

        setMobile(mobile);

        if (mobile.length === 11) {
            setButtonClassName('_bc-g');
            setIsValid(true);
        }
        else {
            setButtonClassName('_bc-g-g');
            setIsValid(false);
        }
    }

    const handleClick = () => {
        if (isValid) {
            fetch(getEndpoint(`/api/android/auth/sendcode?mobile=${mobile}`))
                .then(res => {
                    if (res.ok) history.push(`/verify/${mobile}`);
                    else console.log('FETCH ERROR >', res.status, res.statusText);
                });
        }
    }

    return (
        <div className="d-f ai-c jc-c h-100vh px-4" style={{ backgroundColor: '#fafafa' }}>
            <div className="w-100">
                <img style={{ width: '10rem' }} className="mx-a" src={getEndpoint('/pwa/img/logo.png')} alt="تامین 360" />
                <div className="ta-c my-5">
                    برای ثبت نام رایگان شماره موبایل خود را وارد نمایید.
                </div>
                <div className={`${(isValid ? 'ok' : '')} auth-wrap p-r`}>
                    <input name="mobile"
                        className="auth br-4 bw-1 bc--n3 ta-c f:o-n w-100 py-2"
                        pattern="\d*"
                        type="number"
                        maxLength="11"
                        placeholder="شماره موبایل"
                        value={mobile}
                        onChange={handleMobileChange} />
                    <button
                        onClick={handleClick}
                        className={`${buttonClassName} c-w d-f ai-c jc-c w-100 br-4 py-2 us-n mt-4`}
                        children='دریافت رمز موقت'
                    />
                </div>
            </div>
        </div>
    )
}